import { useGetAssessment } from "@/api/app/assessment/useGetAssessment";
import LoadingScreen from "@/components/Loading";
import AppContentContainer from "@/src/app/(auth)/_components/AppContentContainer";
import CategoryTable from "@/src/app/(auth)/assessment/_components/CategoryTable";
import DocumentList from "@/src/app/(auth)/assessment/_components/DocumentList/DocumentList";
import Header from "@/src/app/(auth)/assessment/_components/Header/Header";
import ProgressStatus from "@/src/app/(auth)/assessment/_components/ProgressStatus";
import { useTranslation } from "react-i18next";

function Assessment() {
  const { t } = useTranslation();

  const { data: assessmentData, isLoading: isAssessmentLoading } =
    useGetAssessment({});

  if (isAssessmentLoading || !assessmentData) {
    return <LoadingScreen />;
  }

  const {
    id,
    has_first_evaluation_report,
    has_second_evaluation_report,
    has_improvement_proposal,
    categories,
    company_document_files,
    expired_at,
    status,
    submitted_at,
  } = assessmentData.data;
  const isAllAnswered = categories.every((category) => category.is_answered);

  return (
    <>
      <AppContentContainer className="px-16 py-8">
        <Header
          id={id}
          status={status}
          hasFirstReport={has_first_evaluation_report}
          hasSecondReport={has_second_evaluation_report}
          hasImprovementProposal={has_improvement_proposal}
          expiredAt={expired_at}
          submittedAt={submitted_at}
          isAllAnswered={isAllAnswered}
        />
        <div className="mt-4 rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700">
          {t("assessment-info-message")}
        </div>
        <ProgressStatus status={status} />
        <div className="mt-8">
          <CategoryTable data={categories} />
        </div>
        <div className="mt-8">
          <DocumentList status={status} data={company_document_files} />
        </div>
      </AppContentContainer>
    </>
  );
}

export default Assessment;
